module.exports = __webpack_public_path__ + "img/fit-logo.0af1a2d6.jpg";